<template>
  <div>
    <!-- Preloader Starts -->
    <div class="preloader">
      <div class="spinner">拿度</div>
    </div>
    <!-- Preloader End -->
    <!-- Header Area Starts -->
    <header class="header-area single-page yincang">
      <div class="header-top">
        <div class="container header912">
          <div class="row">
            <div class="col-lg-2">
              <div class="logo-area">
                <a href="/"><img src="static/assets/images/logoc.png" alt="logo"></a>
              </div>
              <div class="diannao-sous">
                    <img src="../static/assets/images/sech.png" style="width: 18px; margin-top: 25px; display: inline-block;cursor: pointer;" @click="toggleVisibility" />
              </div>

              <div class="custom-navbar sandaogang" @click="isVisibleb=flase">
                <span style="height:2px;"></span>
                <span style="height:1px;"></span>
                <span style="height:2px;"></span>
              </div>
            </div>

            <div class="col-lg-10">

              <div class="main-menu main-menu-light">
                <ul>
                    <div v-if="!isVisible" class="custom-navbarc" style="width: 100%;height: 100%;background: rgb(0 0 0 / 8%);  position: fixed;  z-index: -4;  left: 0px; bottom: 0px;">
                    
                    </div>

                  <li class="active"><a href="/">网站首页</a></li>

                  <li v-for="(item, index) in daohanglist" :key="index">
                    <router-link :to="item.gnote" @click.native="reloadPage">{{ item.name }}</router-link>

                    <ul v-if="item.son.length > 0" class="sub-menu">
                      <div style="color: #FFFFFF;font-size: 30px;" class="toubu_ziti2">
                        {{ item.name }} / <span style="font-size: 18px;font-weight: 500;">{{ item.filename }}</span>
                        <p style="font-size: 16px; line-height: 50px;color: #ffffffad;" class="toubu_ziti1">
                          专注于工业自动化测控领域的应用产品开发与技术服务
                        </p>
                      </div>
                      <li v-for="(itema, indexa) in item.son" :key="indexa"><router-link :to="itema.gnote"
                          @click.native="reloadPage">{{ itema.name }}</router-link></li>
                      <div style="float: right; top: 100px; position: absolute; right: 10%;" class="toubu_tubiao">
                        <img src="/static/assets/images/bailogo.png" />
                      </div>
                    </ul>
                  </li>


                  <!-- <li><router-link to="/about" @click.native="reloadPage">关于我们</router-link>
					<ul class="sub-menu">
					 <div style="color: #FFFFFF;font-size: 30px;">
						 关于我们 / <span style="font-size: 18px;font-weight: 500;">ABOUT</span>
						 <p style="font-size: 16px; line-height: 50px;color: #ffffffad;">
							专注于工业自动化测控领域的应用产品开发与技术服务 
						 </p>
					 </div>
					  <li><router-link to="/about" @click.native="reloadPage">企业简介</router-link></li>
					  <li><router-link to="/wenhua" @click.native="reloadPage">企业文化</router-link></li>
					  <li><router-link to="/jiagou" @click.native="reloadPage">企业架构</router-link></li>
					  <li><router-link to="/zeren" @click.native="reloadPage">认证体系</router-link></li>
					  <li><router-link to="/shengming" @click.native="reloadPage">版权声明</router-link></li>
					  <div style="float: right; top: 100px; position: absolute; right: 10%;">
						  <img src="/static/assets/images/bailogo.png"/>
					  </div>
					</ul>
				</li>
				
				
                <li><router-link to="/category" @click.native="reloadPage">产品中心</router-link>
					<ul class="sub-menu">
										  <div style="color: #FFFFFF;font-size: 30px;">
										  						 产品中心 / <span style="font-size: 18px;font-weight: 500;">PRODUCTS</span>
										  						 <p style="font-size: 16px; line-height: 50px;color: #ffffffad;">
										  							专注于工业自动化测控领域的应用产品开发与技术服务 
										  						 </p>
										  </div>
					  <li><router-link to="/category" @click.native="reloadPage">磁致传感器</router-link></li>
					  <li><router-link to="/category" @click.native="reloadPage">激光测距仪</router-link></li>
					  <li><router-link to="/category" @click.native="reloadPage">静力水准仪</router-link></li>
					  
										<div style="float: right; top: 100px; position: absolute; right: 10%;">
																  <img src="/static/assets/images/bailogo.png"/>
										</div>
					</ul>
				</li>
				
				
				<li><router-link to="/blog" @click.native="reloadPage">新闻中心</router-link>
				  <ul class="sub-menu">
					  <div style="color: #FFFFFF;font-size: 30px;">
					  						 新闻中心 / <span style="font-size: 18px;font-weight: 500;">NEWS</span>
					  						 <p style="font-size: 16px; line-height: 50px;color: #ffffffad;">
					  							专注于工业自动化测控领域的应用产品开发与技术服务 
					  						 </p>
					  </div>
				    <li><router-link to="/blog" @click.native="reloadPage">企业新闻</router-link></li>
				    <li><router-link to="/blog" @click.native="reloadPage">国内新闻</router-link></li>
					<div style="float: right; top: 100px; position: absolute; right: 10%;">
											  <img src="/static/assets/images/bailogo.png"/>
					</div>
				  </ul>
				</li>
				
				
				
                <li><router-link to="/fuwu" @click.native="reloadPage">技术服务</router-link>
					<ul class="sub-menu">
										  <div style="color: #FFFFFF;font-size: 30px;">
										  		技术服务 / <span style="font-size: 18px;font-weight: 500;">TECHNICAL SERVICE</span>
										  		<p style="font-size: 16px; line-height: 50px;color: #ffffffad;">
													专注于工业自动化测控领域的应用产品开发与技术服务 
										  		</p>
										  </div>
					  <li><router-link to="/fuwu" @click.native="reloadPage">服务与支持</router-link></li>
					  <li><router-link to="/fangan" @click.native="reloadPage">解决方案</router-link></li>
										<div style="float: right; top: 100px; position: absolute; right: 10%;">
																  <img src="/static/assets/images/bailogo.png"/>
										</div>
					</ul>
				</li>

				
				
				<li><router-link to="/yingyong" @click.native="reloadPage">行业应用</router-link></li>
				
				
                <li><router-link to="/jobSingle" @click.native="reloadPage">合作伙伴</router-link>
                  <ul class="sub-menu">
					  <div style="color: #FFFFFF;font-size: 30px;">
					  						 合作伙伴 / <span style="font-size: 18px;font-weight: 500;">PARTNERS</span>
					  						 <p style="font-size: 16px; line-height: 50px;color: #ffffffad;">
					  							专注于工业自动化测控领域的应用产品开发与技术服务 
					  						 </p>
					  </div>
                    <li><router-link to="/jobSingle" @click.native="reloadPage">战略合作伙伴</router-link></li>
                    <li><router-link to="/pricingPlan" @click.native="reloadPage">商务合作伙伴</router-link></li>
					<div style="float: right; top: 100px; position: absolute; right: 10%;">
											  <img src="/static/assets/images/bailogo.png"/>
					</div>
                  </ul>
                </li>
				
				
				
				
				<li><router-link to="/contact" @click.native="reloadPage">联系我们</router-link></li> -->




                 
                </ul>

                <div v-if="isVisibleb" class="diannao-sous-kuang">
                      <input type="text" v-model="keyValue" placeholder="请输入内容" class="inputValue"
                      style="background-color: transparent;border: solid 1px white; font-size: 14px; color: white;height: 36px;padding: 6px;border-radius: 5px;">
                      <router-link :to="{ path: '/yingyong', query: { key: keyValue } }" @click.native="reloadPage"
                        class="login" style="display: inline-block; font-size: 14px; line-height: 35px; padding: 0px 10px;border-radius: 5px;background: #007bff;">
                        搜索
                      </router-link>
                    </div>
                    
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--    <div class="page-title text-center">
      <div class="container">
        <div class="row">
          <div class="col-md-6 offset-md-3">
            <h2>国家高新技术企业，国家级农化服务中心</h2>
            <p>年产150万吨尿素、140万吨甲醇、30万吨乙二醇</p>
          </div>
        </div>
      </div>
    </div> -->
    </header>
    <!-- Header Area End -->


    <router-view></router-view>

    <!-- Footer Area Starts -->
    <footer class="footer-area section-padding">
      <div class="footer-widget">
        <div class="container">
          <div class="row">

            <div class="col-xl-5 offset-xl-1 col-lg-6">
              <div class="single-widget-home mb-5 mb-lg-0 donghuaLeft phone_weibu_kd"
                style="animation-duration: 0.5s; animation-delay: 0.3s;">
                <h3 class="mb-4 phone_weibu_zt1" style="font-weight: 500;font-size: 22px;">专业技术团队 提供全方位系统解决方案</h3>
                <p class="mb-4" style="color: #7a7a7a;line-height: 60px;">如有任何疑问 请随时与我们联系</p>
                <form>

                  <input type="messname" v-model="messname" placeholder="您的姓名" onfocus="this.placeholder = ''"
                    onblur="this.placeholder = '您的姓名'" required>
                  <input type="messtel" v-model="messtel" placeholder="您的电话" onfocus="this.placeholder = ''"
                    onblur="this.placeholder = '您的电话'" required>
                  <input type="messtitle" v-model="messtitle" placeholder="您的留言" onfocus="this.placeholder = ''"
                    onblur="this.placeholder = '您的留言'" required>
                  <button type="submit" class="template-btnb" @click="buttonmess"
                    style="background: rgb(0 100 207);">立即提交</button>
                </form>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="footer-copyright weibu_sun">
        <div class="container weibu912" style="padding-top: 50px;">
          <div class="weibu_a">
            <img src="/static/assets/images/logob.png" />
            <div class="image-counter">
              <div class="image-containerc"></div>
              <div class="image-containera"></div>
              <div class="image-containerb"></div>
              <!-- <img src="/static/assets/images/weixin.png" style="width: 35px;height: 35px;">
    			<img src="/static/assets/images/douyin.png" style="width: 35px;height: 35px;">
    			<img src="/static/assets/images/weibo.png" style="width: 35px;height: 35px;"> -->
            </div>
          </div>
          <div class="weibu_b donghuasun" style="animation-duration: 0.6s; animation-delay: 0.4s;">
            <p>工业物联网整体解决方案服务商</p>
            <p>智能传感解决方案专家</p>
          </div>
          <div class="weibu_c donghuasun" style="animation-duration: 0.6s; animation-delay: 0.5s;">
            <p>{{ zhandianinfo.copyright }}</p>
            <p>总部公司 : {{ qiyeinfo.address }}</p>
            <p>服务热线 : {{ qiyeinfo.mobile }}</p>
            <p>主营产品 : {{ qiyeinfo.other }}</p>
            <p>{{ zhandianinfo.icp }} <i><img src="/static/assets/images/gongan.png"
                  style="width:16px; height:16px;margin-bottom: 5px;"></i></p>
          </div>
        </div>
      </div>

    </footer>
    <!-- Footer Area End -->

  </div>
</template>
<script>
import axios from 'axios';
export default {
  data() {
    return {
      qiyeinfo: [],
      zhandianinfo: [],
      daohanglist: [],
      messtel: '',
      messname: '',
      messtitle: '',
      isVisibleb: false,
      keyValue: ''
    }
  },
  mounted() {
    //公司信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.qiyeinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //站点信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.zhandianinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //导航数据
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.daohanglist = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });




  },
  methods: {
    toggleVisibility(){
      console.log('3333')
          this.isVisibleb = !this.isVisibleb;
    },

    reloadPage() {
      // console.log('3333')
      // 如果不是因为导航重复而出现错误，则重新加载页面
      window.location.reload()
    },
    //提交留言
    buttonmess() {
      // Message.success(`输入的内容是: ${this.messtitle}`);
      if (this.messname != '' && this.messtel != '' && this.messtitle) {
        // console.log('可以继续进行');
        // console.log('输入的内容是:', this.messname);
        // console.log('输入的内容是:', this.messtel);
        // console.log('输入的内容是:', this.messtitle);
        axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/addmsg', {
          name: this.messname,
          tel: this.messtel,
          content: this.messtitle,
          appid: 'jurenkeji2024',
          timestamp: '1722845854',
          signature: '0eb76b812e96966c380b90c6e7416a26'
        })
          .then(response => {
            // console.log(response.data.data);
            // that.bannerlist = response.data.data;
            alert('留言提交成功!');
            this.messname = '';
            this.messtel = '';
            this.messtitle = '';
          })
          .catch(error => {
            console.error('当前网络环境异常!', error);
          });

      } else {
        alert('内容不能为空');
        return;
        // console.log('不能为空');
      }

    }

  }
}
</script>

<style>
.custom-navbarc{
  display:none;
}
input[type="text"] {
  background-color: transparent;
  border: solid 1px white;
  color: white;
  height: 40px;
  padding: 10px;
  border-radius: 5px;
}

input[type="text"]::placeholder {
  color: white;
}

@media only screen and (min-width: 100px) and (max-width: 750px) {
  .inputValue {
    background-color: transparent;
    border: 1px solid white;
    color: white;
    height: 36px;
    padding: 6px;
    border-radius: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?0e7f3bb0